export const formatFilterNameToValue = (name: string) => {
  return name.trim().replace(/\s/g, '-').toLowerCase();
};
